/**
 * 商机管理服务 - 商机相关 API
 * 路径与后端 /crm/opportunities 对齐
 */

import api from '../../api';
import type { Result, PageResult } from '../../types';
import type { Opportunity } from '../../../types';
import type { OpportunitySignDraft } from '../../../pages/modules/crm/opportunities/utils/opportunitySignDraft';

export const getOpportunities = (params: Record<string, unknown>): Promise<Result<PageResult<Opportunity>>> => {
  return api.get('/crm/opportunities', { params });
};

export const getOpportunityById = (id: string): Promise<Result<Opportunity>> => {
  return api.get(`/crm/opportunities/${id}`);
};

export const createOpportunity = (data: Record<string, unknown>): Promise<Result<string>> => {
  return api.post('/crm/opportunities', data);
};

export const updateOpportunity = (id: string, data: Record<string, unknown>): Promise<Result<void>> => {
  return api.put(`/crm/opportunities/${id}`, data);
};

export const deleteOpportunity = (id: string): Promise<Result<void>> => {
  return api.delete(`/crm/opportunities/${id}`);
};

/** 与后端 `PUT /{id}/stage?stage=&reason=` 一致；阶段变更须填写跟进说明 */
export const updateOpportunityStage = (id: string, stage: string, reason: string): Promise<Result<void>> => {
  return api.put(`/crm/opportunities/${id}/stage`, null, { params: { stage, reason } });
};

/** @deprecated 请使用 updateOpportunityStage */
export const updateOpportunityStatus = updateOpportunityStage;

export const signContract = (id: string, data: Record<string, unknown>): Promise<Result<void>> => {
  return api.post(`/crm/opportunities/${id}/sign`, data);
};

export const getOpportunitySignDraft = (id: string): Promise<Result<OpportunitySignDraft | null>> => {
  return api.get(`/crm/opportunities/${id}/sign-draft`);
};

export const getOpportunityStats = (): Promise<Result<Record<string, unknown>>> => {
  return api.get('/crm/opportunities/statistics');
};

export const updateProbability = (id: string, probability: number): Promise<Result<void>> => {
  return api.put(`/crm/opportunities/${id}/probability`, null, { params: { probability } });
};

export const updateProgress = (id: string, progress: number): Promise<Result<void>> => {
  return api.put(`/crm/opportunities/${id}/progress`, null, { params: { progress } });
};

export const assignOwner = (id: string, ownerId: string, ownerName: string): Promise<Result<void>> => {
  return api.put(`/crm/opportunities/${id}/owner`, null, { params: { ownerId, ownerName } });
};

export const markAsLost = (id: string, reason: string): Promise<Result<void>> => {
  return api.post(`/crm/opportunities/${id}/lose`, null, { params: { reason } });
};

export const getByCompanyId = (companyId: string): Promise<Result<Opportunity[]>> => {
  return api.get(`/crm/opportunities/by-company/${companyId}`);
};

export const batchDelete = (ids: string[]): Promise<Result<void>> => {
  return api.delete('/crm/opportunities/batch', { data: ids });
};
